let state = {
    count: 0
}

const mutations = {
    setCount(state, count) {
        state.count = count>0 ? count: 0
    }
}

export default {
    state,
    mutations
}
